// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".creator-cell__e3dUSqOS{align-items:center;display:flex}.status-enabled__sIzVEDcT{color:var(--green2)}.status-disabled__gVSzlFAG{color:var(--gray3)}.status-archived__ToJWYY0j{color:var(--red2)}.tags__ZimV0dtA{color:var(--text-light)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"creatorCell": "creator-cell__e3dUSqOS",
	"statusEnabled": "status-enabled__sIzVEDcT",
	"statusDisabled": "status-disabled__gVSzlFAG",
	"statusArchived": "status-archived__ToJWYY0j",
	"tags": "tags__ZimV0dtA"
};

/*** EXPORTS FROM exports-loader ***/
export default ___CSS_LOADER_EXPORT___.toString();
